import { FunctionComponent } from 'react';
import { useTranslation } from 'react-i18next';
import { Col, FormCheckbox, Row } from '@monorepo/react-components';
import { NyseFormProps } from '../nyse-modal-content';

import './nyse-steps.scss';

const NyseStepNine: FunctionComponent<NyseFormProps> = ({ form }) => {
  const { t } = useTranslation(['contractModal', 'common']);

  return (
    <div className={'contracts-steps-body'}>
      <div>
        <p>{t('contractModal:nyse_modal.certification')}</p>
        <div>
          <Row gutter={8}>
            <Col className={'agreement-check'}>
              <FormCheckbox
                form={form}
                controllerProps={{ name: 'signThatProvidedDataIsCorrect' }}
              />
            </Col>
            <Col>
              <span>{t('common:agree')}</span>
            </Col>
          </Row>
        </div>
      </div>
    </div>
  );
};

export default NyseStepNine;
